import BaseElement from '../base/element';

export default class Element extends BaseElement {
}
